import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController, ModalController } from 'ionic-angular';
import { CongresosProvider } from '../../providers/congresos/congresos';
import { File } from '@ionic-native/file';
import { Base64 } from '@ionic-native/base64';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Observable, Observer } from 'rxjs';
import { EditortextoPage } from '../editortexto/editortexto';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the PresentacionEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@IonicPage(
  {name:'page-presentacion-edit'}
)
@Component({
  selector: 'page-presentacion-edit',
  templateUrl: 'presentacion-edit.html',
})
export class PresentacionEditPage {
  @ViewChild('input') myInput ;
  public Editor = ClassicEditor;
  public base64Image: string;
  public base64textString;
  public imgpresentacion;
  public imgicono;
  public imgcartel;
  public imgcabecera;
  public congresoactivo;
  constructor(public global: GlobalProvider,public modalCtrl: ModalController,private camera: Camera, public alertCtrl: AlertController, private base64: Base64, private file: File, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public congresoProvider: CongresosProvider) {


    /* removePlugins: [ 'Image' ]*/
    /* ClassicEditor.create(document.querySelector( '#Editor' ),{
      toolbar: [ 'heading', 'italic', 'link', '|', 'bold', 'bulletedList', 'numberedList', 'blockQuote' ],
      heading: {
          options: [
              { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
              { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
              { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
          ]
      }
  } )
  .catch( error => {
      console.log( error );
  } );*/

    this.congresoactivo = navParams.get("congresoactivo");
  
    if (this.congresoactivo.imgpresentacion) {
      this.imgpresentacion = this.congresoactivo.imgpresentacion;
      /*alert('/api/uploads/' + this.congresoactivo.imgpresentacion);
      let filePath: string = 'http://192.168.1.161/ionic3/micongreso/api/uploads/' + this.congresoactivo.imgpresentacion;
      this.base64.encodeFile(filePath).then((base64File: string) => {
        this.imgpresentacion = "data:image/jpeg;base64," + base64File;
        alert(this.imgpresentacion);
      }, (err) => {
        console.log(err);
      });*/
      
     // this.convertToDataURLviaCanvas3('/api/uploads/' + this.congresoactivo.imgpresentacion, "image/jpeg").then(base64 => this.imgpresentacion = base64)

    }
   
  }
 
  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
    
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        //alert('1a');
        img.onload = () => {
          //alert('ok');
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          //alert('err');
          observer.error(err);
        };
      } else {
        //alert('1b');
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CongresoEditPage');
  }

  cerrar() {
    this.viewCtrl.dismiss();
  }
  checkBlur(){
    //alert('fuera');
  }

  grabacongreso() {
    this.congresoactivo.imgpresentacion=this.imgpresentacion;
    this.congresoProvider.update_presentacion(this.congresoactivo).subscribe();
   
    this.viewCtrl.dismiss();
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];

    if (files && file) {

    //  if (file.size / 1048576 < 0.5) {
        var reader = new FileReader();

        reader.onload = this._handleReaderLoaded.bind(this);

        reader.readAsBinaryString(file);
    /*  } else {
        alert("tamaño" + file.size / 1048576);
      }*/
      //1048576

    }
  }

  carga_editor() {
    let myModal = this.modalCtrl.create(EditortextoPage, {
      texto: this.congresoactivo.descripcionlarga
    }, { enableBackdropDismiss: false, cssClass: "modal-fullscreen" });
    myModal.present();
    myModal.onDidDismiss(data => {
      //this.myInput.setFocus();
      if (data) {
        this.congresoactivo.descripcionlarga=data.texto;
      }
    });   
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    console.log(btoa(binaryString));
    this.imgpresentacion = "data:image/jpeg;base64," + this.base64textString;
   
  }



  changeListener($event): void {
    this.file = $event.target.files[0];
    let filePath: string = this.file['name'];
    this.base64.encodeFile(filePath).then((base64File: string) => {
      this.imgpresentacion = "data:image/jpeg;base64," + base64File;
    }, (err) => {
      console.log(err);
    });

  }

  deletePhoto() {
    let confirm = this.alertCtrl.create({
      title: 'Estas seguro de borrar la foto?',
      cssClass: "messagealert2",

      message: '',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, {
          text: 'Si',
          handler: () => {
            console.log('Agree clicked');
            this.imgpresentacion = "";
            // this.datos_pista.archivo="";
            // this.photos.splice(index, 1);
          }
        }
      ]
    });
    confirm.present();
  }
 


  takePhoto() {

    let confirm = this.alertCtrl.create({
      title: 'Imagen',
      message: 'Selecciona imagen',
      cssClass: "messagealert2",

      buttons: [
        {
          text: 'Camara',
          handler: () => {

            const options: CameraOptions = {
              quality: 50,
              destinationType: this.camera.DestinationType.DATA_URL,
              sourceType: this.camera.PictureSourceType.CAMERA,
              //sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
              encodingType: this.camera.EncodingType.JPEG,
              mediaType: this.camera.MediaType.PICTURE,
              saveToPhotoAlbum: false,
              correctOrientation: true
              // picture quality
							/*destinationType: this.camera.DestinationType.DATA_URL,
							encodingType: this.camera.EncodingType.JPEG,
							mediaType: this.camera.MediaType.PICTURE*/
            }
            this.camera.getPicture(options).then((imageData) => {
              this.base64Image = "data:image/jpeg;base64," + imageData;
              this.imgpresentacion = this.base64Image;
              //	this.photos.push(this.base64Image);
              //	this.photos.reverse();
            }, (err) => {
              console.log(err);
            });
          }
        }, {
          text: 'Fichero',
          handler: () => {
            const options: CameraOptions = {
              quality: 50,
              destinationType: this.camera.DestinationType.DATA_URL,
              sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
              //sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
              encodingType: this.camera.EncodingType.JPEG,
              mediaType: this.camera.MediaType.PICTURE,
              saveToPhotoAlbum: false,
              correctOrientation: true
              // picture quality
							/*destinationType: this.camera.DestinationType.DATA_URL,
							encodingType: this.camera.EncodingType.JPEG,
							mediaType: this.camera.MediaType.PICTURE*/
            }
            this.camera.getPicture(options).then((imageData) => {
              this.base64Image = "data:image/jpeg;base64," + imageData;
              this.imgpresentacion = this.base64Image;
              //	this.photos.push(this.base64Image);
              //	this.photos.reverse();
            }, (err) => {
              console.log(err);
            });

          }
        }
      ]
    });


    confirm.present();
  }
   
}



// WEBPACK FOOTER //
// ./src/pages/presentacion-edit/presentacion-edit.ts